import { Pipe, PipeTransform } from '@angular/core';
import { NumberUtils } from '../utils';

@Pipe({
  name: 'roundNumberFormatter',
  pure: false,
})
export class RoundNumberFormatterPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (!value) {
      return value;
    }

    const decimalDigit: number = NumberUtils.isNumber(args?.[0])
      ? args?.[0]
      : 2;

    return NumberUtils.roundNumber(value, decimalDigit);
  }
}
